import { render, staticRenderFns } from "./NeetAsignados.vue?vue&type=template&id=465ef2a9&scoped=true"
import script from "./NeetAsignados.vue?vue&type=script&lang=js"
export * from "./NeetAsignados.vue?vue&type=script&lang=js"
import style0 from "./NeetAsignados.vue?vue&type=style&index=0&id=465ef2a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ef2a9",
  null
  
)

export default component.exports